import { TApplicationState } from '../../types/redux';
import { selectExperiments } from './selectExperiments';
import { MY_HOME_BY_FLAT_NUMBER } from '../../../common/utils/constants';

export const selectIsFormWithRoomNumberExperiment = (state: TApplicationState): boolean => {
  const experiments = selectExperiments(state);

  const experimentGroup = experiments.find(
    ({ experimentName }) => experimentName === MY_HOME_BY_FLAT_NUMBER,
  )?.groupName;

  return experimentGroup === 'B';
};
